







































import ProgressBar from "@/components/ProgressBar.vue";
import IAvatar from "@/typings/IAvatar";
import "lazysizes";
import { Component, Vue } from "vue-property-decorator";

/**
 * The view used to select an avatar instead of taking a photo.
 */
@Component({
  components: { ProgressBar }
})
export default class Avatar extends Vue {
  /**
   * The base app URI configured in env.
   */
  private get apiUri(): string | undefined {
    return process.env.VUE_APP_API_URI;
  }

  /**
   * The currently selected avatar.
   */
  private get avatar(): IAvatar | undefined {
    return this.$store.getters.avatar;
  }

  /**
   * The ID of the currently selected avatar.
   */
  private get avatarId(): number | null {
    return this.$store.getters.avatarId;
  }

  /**
   * The list of available avatars.
   */
  private get avatarList(): IAvatar[] {
    return this.$store.getters.avatarList;
  }

  /**
   * The progress bar's current progress level.
   */
  private get progress(): number {
    return this.$store.getters.progress;
  }

  /**
   * Handles the selection of an avatar.
   */
  private handleSelectAvatar(avatarId: number): void {
    if (!this.avatar) {
      this.$store.dispatch("incrementProgress");
    }
    this.$store.dispatch("updateAvatarId", avatarId);
    setTimeout(() => {
      this.$router.push("/survey");
    }, 200);
  }
}
